import React from 'react';
import {
  Create,
  CreateButton,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  ExportButton,
  Filter,
  List,
  NumberInput,
  Resource,
  SaveButton,
  SelectInput,
  ShowButton,
  ShowGuesser,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
} from 'react-admin';

import PaidRounded from '@mui/icons-material/PaidRounded';
import { ORG_ID } from 'config';
import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import AmountField from 'shared-fields/AmountField';
import ChannelReferenceField from 'shared-fields/ChannelReferenceField';
import ChannelReferenceInput from 'shared-fields/ChannelReferenceInput';
import OrganizationReferenceField from 'shared-fields/OrganizationReferenceField';
import OrganizationReferenceInput from 'shared-fields/OrganizationReferenceInput';
import { generateSelectOptions } from 'utils/filters-utils';
import { rolesMatch } from 'utils/user';
import { CopyField } from 'shared-fields/CopyField';

function IncomeFilter(props) {
  return (
    <Filter {...props}>
      <ChannelReferenceInput alwaysOn />
      {!ORG_ID && <OrganizationReferenceInput alwaysOn />}
    </Filter>
  );
}

export function IncomeListContent() {
  const hasRole = useHasRole();
  return (
    <Datagrid bulkActionButtons={false}>
      <CopyField source="id" label="ID" />
      <AmountField source="amount" />
      <TextField source="currency" />
      <TextField source="description" />
      {!ORG_ID && <OrganizationReferenceField />}
      <ChannelReferenceField />
      <DateField source="createdAt" showTime locales="fa-IR" />
      {
        hasRole(Role.INCOME_EDIT) && (
          <EditButton />
        )
      }
      <ShowButton />
    </Datagrid>
  );
}
export function IncomeList() {
  const hasRole = useHasRole();
  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
      filters={<IncomeFilter />}
      perPage={25}
      actions={(
        <TopToolbar>
          {hasRole(Role.ORG_SUPER_ADMIN) && <ExportButton />}
          {hasRole(Role.FINANCIAL_MANAGEMENT) && <CreateButton />}
          {/* <FilterButton filters={<IncomeFilter />} /> */}
        </TopToolbar>
      )}
    >
      <IncomeListContent />
    </List>
  );
}

export function IncomeEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={(
        <Toolbar>
          <SaveButton />
        </Toolbar>
      )}
      >
        <TextInput source="id" disabled />
        <NumberInput source="amount" disabled />
        <TextInput source="currency" disabled />
        <TextInput source="description" multiline />
        {!ORG_ID && <OrganizationReferenceInput />}
        <ChannelReferenceInput disabled />
      </SimpleForm>
    </Edit>
  );
}

export function IncomeCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <NumberInput source="amount" />
        <TextInput source="currency" defaultValue="GBP" />
        <TextInput source="description" />
        <ChannelReferenceInput />
      </SimpleForm>
    </Create>
  );
}

export const renderIncomeResource = (roles) => (
  <Resource
    name="incomes"
    icon={PaidRounded}
    show={ShowGuesser}
    list={IncomeList}
    edit={rolesMatch({ roles, role: Role.INCOME_EDIT }) && IncomeEdit}
    create={rolesMatch({ roles, role: Role.INCOME_CREATE }) && IncomeCreate}
  />
);
